import { render, staticRenderFns } from "./template_copy.vue?vue&type=template&id=2d23862f&scoped=true"
import script from "./template_copy.vue?vue&type=script&lang=js"
export * from "./template_copy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d23862f",
  null
  
)

export default component.exports